<template>
    <div class="autoRenew">
        <Navbar :statusHeight="statusHeight" :title="$t('自动续费管理')" :backIcon="require('@/assets/icon_back.png')"
            background="#FFFFFF" :isNavtiveBack="true" />
        <div class="container">
            <div class="autoRenew-box">
                <div class="autoRenew-item-title-text">
                    <span>{{ isRenew ? memberProduct.name : $t('自动续费') }}</span>
                    <p>{{ isRenew ? $t('续费xx元/月', { value: memberProduct.price }) : $t('会员享受13大直播特权') }}</p>
                </div>
                <div class="autoRenew-switch" @click="handleRenew">
                    {{ $t(isRenew ? '取消自动续费' : '开通自动续费') }}
                </div>
            </div>
        </div>
        <van-action-sheet v-model="sheetShow" :closeable="false" @closed="sheetClose">
            <div class="content">
                <div class="privilege-contorl">
                    <van-swipe ref="swipe" :autoplay="3000" indicator-color="#C498FE">
                        <van-swipe-item v-for="(item, index) in privilegeList" :key="index">
                            <div class="vip-privilege-item">
                                <img class="vip-privilege-item-icon" :src="item.icon" alt="">
                                <div class="vip-privilege-item-text">
                                    <p :class="['vip-privilege-item-text-title', language]">{{ $t(item.title) }}</p>
                                    <p class="vip-privilege-item-text-desc">{{ $t(item.desc) }}</p>
                                </div>
                            </div>
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <div class="vip-box">
                    <div class="vip-list">
                        <div class="vip-list-box">
                            <div class="vip-list-contorl">
                                <div :class="['vip-list-item', activeVipIndex === index && 'vip-list-item-active']"
                                    v-for="(item, index) in memberProducts" :key="item.id"
                                    @click="activeVipIndex = index">
                                    <div class="layer_vip_box">
                                        <div :class="['vip-list-item-text', language]">
                                            <div class="vip-list-item-title">{{ language === 'ug' ? item.nameUig : item.name
                                            }}</div>
                                            <div class="vip-list-item-price" v-if="item.validDays === 30 && item.type === 1">¥<span>{{ isFirst ? item.firtstPrice : item.currentPrice }}</span><i
                                                    :style="{ padding: language == 'ug' ? '0 2px' : 0 }">/</i>{{ $t('月') }}
                                            </div>
                                            <div class="vip-list-item-price" v-else>¥<span>{{ item.monthlyPrice }}</span><i
                                                    :style="{ padding: language == 'ug' ? '0 2px' : 0 }">/</i>{{ $t('月') }}
                                            </div>
                                            <div class="vip-list-item-free"><span>¥{{ item.firtstPrice || item.currentPrice
                                            }}</span><span class="vip-list-item-price-origin">¥{{ item.originalPrice
                                                    }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="first-renew-desc" v-if="item.firtstPrice">{{ $t('首月')
                                    }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vip-list-desc">
                        {{ resultDesc() }}
                    </div>
                </div>
                <div class="vip-buy">
                    <div :class="['vip-buy-btn', language]" @click="handelBuy"> <van-loading v-if="payLoading" size="16"
                            type="spinner" color="#FFFFFF" /> <span class="btn-text">{{ $t('立即开通') }}</span></div>
                    <div class="vip-buy-agreement">
                        <img @click="isAgreement = !isAgreement"
                            :src="require(`../../assets/livevip/vip-agreement-${isAgreement ? 'select' : 'none'}.png`)"
                            alt="">
                        <div class="vip-buy-agreement-text">{{ $t("请阅读并同意") }} <span
                                @click="toWebView('https://source.cdtongxiaoyun.com/web/mungdax-Live-service.html', '《会员服务协议》')">{{
                                    $t('《会员服务协议》') }}</span>、<span
                                @click="toWebView('https://source.cdtongxiaoyun.com/web/mungdax-Live-Membership.html', '《自动订阅服务协议》')">{{
                                    $t('《自动订阅服务协议》') }}</span></div>
                    </div>
                </div>
            </div>
        </van-action-sheet>

        <van-dialog v-model="isUnRenew" :showConfirmButton="false">
            <div class="dialog-container">
                <p :class="['dialog-title', language]">{{ $t('确认取消自动续费') }}</p>
                <p class="dialog-content">{{ $t('取消续费订阅将失去当前享受的13项会员权益,可能也将失去当前续费的优惠价格。') }}</p>
                <div class="dialog-btn">
                    <div :class="['dialog-submit', language == 'ug' && 'dialog-submit-ug']" @click="cancelAutoRenew">{{
                        $t('狠心取消') }}</div>
                    <div :class="[language == 'ug' && 'dialog-submit-ug']" @click="isUnRenew = false">{{ $t('再想想') }}
                    </div>
                </div>
            </div>
        </van-dialog>

        <van-dialog v-model="show" :showConfirmButton="false">
            <div class="puy-pay">
                <p :class="['pay-option', language]">{{ $t('选择支付方式') }}</p>
                <div :class="['wxPay', activePay === 'wx' && 'activePay']" @click="handleNoAutoRenewal('wx')">
                    <van-loading v-if="unAutoRenewPayLoading && activePay === 'wx'" size="16" type="spinner"
                        color="#955EFF" />
                    <img src="@/assets/livevip/wx_pay_icon.png" alt="">
                    <span>{{ $t('微信支付') }}</span>
                </div>
                <div :class="['aliPay', activePay === 'ali' && 'activePay']" @click="handleNoAutoRenewal('ali')">
                    <van-loading v-if="unAutoRenewPayLoading && activePay === 'ali'" size="16" type="spinner"
                        color="#955EFF" />
                    <img src="@/assets/livevip/ali_pay_icon.png" alt="">
                    <span>{{ $t('支付宝支付') }}</span>
                </div>
                <div class="close-pay" @click="!unAutoRenewPayLoading && (show = false)">{{ $t('关闭') }}</div>
            </div>
        </van-dialog>
        <!-- 支付表单 -->
        <div class="aliform" v-html="aliform"></div>
    </div>
</template>

<script>
import Vue from 'vue'
import { ActionSheet, Swipe, SwipeItem, Toast } from 'vant';
import Navbar from '@/components/Navbar.vue';
Vue.use(ActionSheet).use(Swipe).use(SwipeItem);
import pay from './mixin/pay'
import config from './mixin/config'
import { userDeleteContract } from '@/api'

export default {
    components: {
        Navbar
    },
    mixins: [pay, config],
    data() {
        return {
            languag: 'ug',
            show: false,
            activePay: '',
            sheetShow: false,
            isUnRenew: false,
            statusHeight: 0,
            activeVipIndex: 0,
            isAgreement: false,
            privilegeList: [
            { title: '头像框', desc: '等级专属头像框', icon: require('../../assets/livevip/privilege-icon01.png'), },
                { title: '进场特效', desc: '璀璨降临震撼全场', icon: require('../../assets/livevip/privilege-icon02.png'), },
                { title: '在房防踢', desc: '尊享在房不被踢出', icon: require('../../assets/livevip/privilege-icon03.png'), },
                { title: '昵称变色', desc: '专属颜色彰显尊贵', icon: require('../../assets/livevip/privilege-icon04.png'), },
                { title: '订制礼物', desc: '订制礼物排面十足', icon: require('../../assets/livevip/privilege-icon05.png'), },
                { title: '皮肤卡', desc: '至尊身份以卡识人', icon: require('../../assets/livevip/privilege-icon06.png'), },
                { title: '会员标识', desc: '会员勋章专属标识', icon: require('../../assets/livevip/privilege-icon07.png'), },
                { title: '更换房间背景', desc: '专属功能独一无二', icon: require('../../assets/livevip/privilege-icon08.png'), },
                // { title: '游戏皮肤', desc: '赠送美式8球皮肤7天', icon: require('../../assets/livevip/privilege-icon09.png'), },
                // { title: '游戏皮肤', desc: '赠送对战消消乐皮肤7天', icon: require('../../assets/livevip/privilege-icon10.png'), },
                { title: '修改头像昵称', desc: '多次修改头像昵称', icon: require('../../assets/livevip/privilege-icon11.webp'), },
                { title: '麦位专属表情', desc: '专属表情彰显身份', icon: require('../../assets/livevip/privilege-icon12.webp'), },
                { title: '房间专属装饰', desc: '直播列表展示专属装饰', icon: require('../../assets/livevip/privilege-icon13.webp'), },
                { title: '查看访客', desc: '查看所有看过我的人', icon: require('../../assets/livevip/privilege-icon14.webp'), },
                { title: '生日礼包', desc: '生日当天获得专属礼包', icon: require('../../assets/livevip/privilege-icon15.webp'), },
                // { title: '加速升级', desc: '贵族等级1.5倍加速', icon: require('../../assets/livevip/privilege-icon16.webp'), },
            ],
            userInfo: {},
            memberProducts: [],
            aliform: ''
        }
    },
    methods: {
        sheetClose() {
            this.show = false
            this.activeVipIndex = 0
            this.isAgreement = false
            this.$refs['swipe'].swipeTo(0)
        },
        handleRenew() {
            if (this.isRenew) {
                this.isUnRenew = true
            } else {
                this.sheetShow = true
            }
        },
        cancelAutoRenew() {
            userDeleteContract().then(res => {
                if (res.code == 1001) {
                    Toast(this.$t('自动续费取消成功'))
                    this.isUnRenew = false
                    this.isRenew = false
                    // this.getConfigList()
                }
            })
        }
    },
    async created() {
        this.setLanguage();
        this.statusHeight = +this.$route.query.statusBarHeight;
        await this.getToken()
        this.getConfigList()
        this.payStatus()
    }
}
</script>

<style lang="scss" scoped>
.autoRenew {
    width: 100vw;
    height: 100vh;

    .container {
        border-top: 1px solid #F2F2F6;
        padding: 12px 14px;

        .autoRenew-box {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .autoRenew-item-title-text {
                font-size: 12px;
                color: #777777;

                span {
                    font-size: 16px;
                    color: #181818;
                }

                p {
                    line-height: 24px;
                }
            }

            .autoRenew-switch {
                width: 92px;
                height: 30px;
                line-height: 30px;
                background: linear-gradient(90deg, #F3A5FF 0%, #C498FE 100%);
                border-radius: 37px;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
            }
        }
    }
}

.content {
    // height: 513px;
    box-sizing: border-box;

    .privilege-contorl {
        padding: 20px 80px 0;
        background: linear-gradient(180deg, #EAE3FD 0%, #FFFFFF 100%);


        .vip-privilege-item {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;

            .vip-privilege-item-icon {
                width: 64px;
                height: 64px;
                padding-bottom: 12px;
            }

            .vip-privilege-item-text {
                display: flex;
                flex-direction: column;
                justify-content: center;

                .vip-privilege-item-text-title {
                    font-weight: 500;
                    font-size: 16px;
                    color: #333333;
                    padding-bottom: 8px;
                }

                .vip-privilege-item-text-desc {
                    font-size: 12px;
                    color: #999999;
                }
            }
        }
    }

    .vip-box {
        flex: 1;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        padding-bottom: 12px;

        .vip-list {
            .vip-list-box {
                width: 100%;
                height: 100%;
                overflow-x: scroll;
                padding: 8px 0 12px 0;

                &::-webkit-scrollbar {
                    display: none;
                }
            }


            .vip-list-contorl {
                width: fit-content;
                display: flex;
                flex-wrap: nowrap;
                padding: 0 13px;

                .vip-list-item {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 110px;
                    height: 121px;
                    border-radius: 12px;
                    box-sizing: border-box;
                    margin-right: 8px;
                    background-color: #EBE3FF;
                    position: relative;

                    .layer_vip_box {
                        width: 106px;
                        height: 117px;
                        padding: 17px 0;
                        border-radius: 10.5px;
                        box-sizing: border-box;
                        background: #FFFFFF;
                    }

                    .first-renew-desc {
                        position: absolute;
                        top: -7px;
                        left: 0;
                        width: 40px;
                        height: 18px;
                        line-height: 18px;
                        background: linear-gradient(90deg, #F64003 0%, #FD8B10 100%);
                        border-radius: 7px 3px 7px 0px;
                        font-size: 10px;
                        color: #FFFFFF;
                        text-align: center;
                    }

                    &:last-child {
                        margin-right: 0;
                    }

                    .vip-list-item-text {
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        font-weight: 500;
                        padding: 0 10px;

                        .vip-list-item-title {
                            width: 100%;
                            font-size: 14px;
                            color: #181818;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: center;
                            padding-bottom: 2px;
                        }

                        .vip-list-item-price {
                            font-size: 12px;
                            padding-top: 20px;
                            color: #333333;

                            span {
                                font-weight: bold;
                                font-size: 20px;
                            }
                        }

                        .vip-list-item-free {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 72px;
                            height: 23px;
                            background: #EBE3FF;
                            border-radius: 12px;
                            font-size: 12px;
                            color: #999999;
                            padding: 0 5px;
                            font-weight: 400;
                            box-sizing: border-box;
                            transform: translateY(35px);

                            .vip-list-item-price-origin {
                                text-decoration: line-through;
                                font-size: 10px;
                                padding-left: 6px;
                            }
                        }
                    }
                }

                .vip-list-item-active {
                    background: url('../../assets/livevip/vip-bg.png') no-repeat;
                    background-size: cover;
                    position: relative;

                    .layer_vip_box {
                        background-color: transparent;
                        border: none;
                    }

                    .vip-list-item-price {
                        color: #C498FE !important;
                    }

                    .vip-list-item-free {
                        color: #FFFFFF !important;
                        background: #C498FE !important;
                    }
                }
            }
        }

        .vip-list-desc {
            font-size: 12px;
            color: #999999;
            padding: 0 13px;
            padding-top: 14px;
            line-height: 18px;
        }
    }

    .vip-buy {
        padding: 16px 20px 20px 20px;
        box-shadow: 1px 0px 10px 0px rgba(0, 0, 0, 0.05);

        .vip-buy-btn {
            display: flex;
            justify-content: center;
            height: 48px;
            line-height: 48px;
            background: linear-gradient(90deg, #F3A5FF 0%, #C498FE 100%);
            border-radius: 12px;
            font-weight: 500;
            font-size: 18px;
            text-align: center;
            color: #FFFFFF;

            .btn-text {
                padding-left: 10px;
            }
        }

        .vip-buy-agreement {
            display: flex;
            align-items: center;
            padding: 10px 50px 0 50px;

            img {
                width: 20px;
                height: 20px;
            }

            .vip-buy-agreement-text {
                flex: 1;
                padding-left: 8px;
                font-size: 12px;
                line-height: 16px;
                color: #1E2225;
                text-align: center;

                span {
                    color: #C498FE;
                }
            }
        }
    }
}

.dialog-container {
    width: 322px;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 25px 12px;
    box-sizing: border-box;

    .dialog-title {
        font-weight: 500;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.8);
        text-align: center;
    }

    .dialog-content {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        padding: 20px 17px;
        text-align: center;
    }

    .dialog-btn {
        display: flex;
        justify-content: space-between;

        div {
            width: 145px;
            height: 44px;
            background: linear-gradient(270deg, #955EFF 0%, #C498FE 100%);
            border-radius: 23px;
            text-align: center;
            line-height: 44px;
            font-size: 16px;
            color: #FFFFFF;
        }

        .dialog-submit {
            background: #F3F4F6;
            color: #999999;
        }

        .dialog-submit-ug {
            font-size: 12px;
        }
    }
}

.puy-pay {
    display: flex;
    flex-direction: column;
    align-items: center;

    .pay-option {
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        text-align: center;
        padding: 20px 0;
    }

    .wxPay,
    .aliPay {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 265px;
        height: 48px;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #E8E8E8;
        margin-bottom: 16px;
        transition: all .3s;

        img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            margin-left: 10px;
        }
    }

    .activePay {
        background: rgba(167, 43, 255, 0.1);
        border: 1px solid #C498FE;
        position: relative;

        &::after {
            content: '';
            width: 17px;
            height: 16px;
            background: url('../../assets/livevip/select-pay-icon.png') no-repeat;
            background-size: cover;
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }

    .close-pay {
        width: 265px;
        text-align: center;
        padding: 6px 0 20px 0;
        font-size: 14px;
        color: #777777;
    }
}

.loading {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($color: #000000, $alpha: .3);
    z-index: 99999999;
}

::v-deep .van-swipe {
    padding-bottom: 30px;
}

::v-deep .van-swipe__indicator {
    background-color: rgba(185, 117, 255, 0.2);
}
</style>